<!--
* UIID: UI-DLB-FF-130
* UI Name: FlatFile Layout Version History
* Modify Date: 2020/05/11
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title
        class="headline white--text"
        primary-title
      >{{$t('lbl.flatFileLayout.versionHistory.page_header')}}</v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <template v-slot:button-close>
      <!-- <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <v-card-text class="popup-title pt-0 pb-0">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{this.versionList.FFL_FILE_NAME}}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup top buttons-->
      <v-card-text class="top-btn-display-m">
        <v-row class="ma-0">
          <v-col cols="12" class="pt-0 pb-0">
            <v-btn
              @click="openCheckIn"
              class="btn btn-popup-search float-right"
              color="primary"
              tile
              dark
            >
              <!-- <v-icon small color="white" class="mr-1">fa fa-check-circle</v-icon> -->
              {{$t('btn.flatfileLayout.checkIn')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup top buttons-->

      <!-- [S]  Popup body-->
      <v-card-text class="content-version-section">
        <v-row class="content-covering-m pt-0">
          <v-col cols="12" class="pa-0">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :hide-default-footer="true"
                  :items="historyList"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  height="95"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th class="text-center text-version" style="width:51px">Ver.</th>
                        <th class="text-center text-version" colspan="2" style="width:117px">Select</th>
                        <th class="text-center text-version" style="width:133px">Date</th>
                        <th class="text-center text-version">User</th>
                        <th class="text-center text-version">Change History</th>
                        <th class="text-center text-version" style="width:60px">Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">{{ item.FFL_VERSION }}</td>
                        <td
                          v-if="item.CURVER_YN === 'Y'"
                          class="text-left align-radio"
                          style="width:29px"
                        >
                          <input
                            type="radio"
                            v-model="item.CURVER_YN"
                            :value="item.CURVER_YN"
                            name="matched-map"
                            @click="selectVersion(item)"
                          />
                        </td>
                        <td
                          v-if="item.CURVER_YN === 'N'"
                          class="text-left align-radio"
                          style="width:29px"
                        >
                          <input type="radio" name="matched-map" @click="selectVersion(item)" />
                        </td>
                        <td class="text-left" style="width:87px">
                          <a @click="openCheckOut(item)">Check Out</a>
                        </td>
                        <td class="text-left">{{ item.CRE_DT }}</td>
                        <td class="text-left text-bold">{{ item.CRE_USR }}</td>
                        <td class="text-left">{{ item.CHKIN_COMT }}</td>
                        <td class="text-center">
                          <v-btn small text icon @click="deleteItem(item)">
                            <icon-svg iconName="delete" />
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->

      <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right mr-4">
            <v-btn class="btn btn-delete btn-popup" @click="removeDialog">{{$t('btn.common.close')}}</v-btn>
            <v-btn
              @click="saveVersionHistory"
              class="btn btn-popup-search btn-popup"
              color="primary"
              tile
            >
              <!-- <v-icon small color="white" class="mr-1">fa fa-save</v-icon> -->
              {{$t('btn.common.save')}}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <dialogWindow
      ref="warningDialog"
      :detail="$t('msg.common.warning.detailWarningCheckIn')"
      size="max"
      color="warning"
    ></dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      :detail="$t('msg.common.warning.detailOkConfirm')"
      @select-close="onClickCancel"
      @select-ok="onClickOkay"
      size="max"
      color="confirmation"
      show-cancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      :detail="$t('msg.common.infoConfirm.detail',['delete the selected items'])"
      @select-ok="onClickDelete"
      color="confirmation"
      show-cancel="true"
      size="max"
    ></dialogWindow>
    <dialogWindow
      ref="successDialog"
      :detail="$t('msg.common.saveSuccess',['FlatFile Layout version'])"
      @select-ok="onClickSave"
      color="success"
      size="max"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from "vuex";

import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import { DownloadFile } from "@/vue-dlb/models/DownloadFile";
// 2021.12.06 SPKA-304 svg icon
import IconSvg from "@/vue-caas/components/IconBase.vue";

/* Remove unuse import
import controlData from '../Data/asset-creation/data_control.json';
 */

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  // props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'fileSelected', 'dialogCheckIn', 'versionList','reFreshList'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    selectFile: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    dialogCheckIn: Function,
    versionList: Object,
    reFreshList: Function,
  },
  name: "flatFile-version-history",
  data() {
    return {
      /* Remove unuse code
      warningDialog: false,
      checkOutDialog: false,
      selectedDelete: null,
      successDialog: false,
      map_table_header : controlData[0].flatFile_version_table_header,
      map_table_data : controlData[0].flatFile_version_table_data,
       */
      fileId: "",
      lockedFlag: false,
      versionHistoryItems: {
        header: ["FFL_PRCS_NO"],
        data: [
          {
            FFL_PRCS_NO: "",
          },
        ],
      },
      currentVerItems: {
        header: ["FFL_PRCS_NO", "FFL_HST_NO"],
        data: [
          {
            FFL_PRCS_NO: "",
            FFL_HST_NO: "",
          },
        ],
      },
      lockItems: {
        header: ["FFL_PRCS_NO", "LOCK_YN"],
        data: [
          {
            FFL_PRCS_NO: "",
            LOCK_YN: "",
          },
        ],
      },
      deleteItems: {
        header: ["FFL_PRCS_NO", "FFL_HST_NO", "FILE_ID"],
        data: [
          {
            FFL_PRCS_NO: "",
            FFL_HST_NO: "",
            FILE_ID: "",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("fflayout", {
      historyList: "historyList",
    }),
  },

  methods: {
    queryList() {
      this.versionHistoryItems.data[0].FFL_PRCS_NO = this.versionList.FFL_PRCS_NO;

      Store.dispatch(
        "fflayout/queryHistoryList",
        this.versionHistoryItems
      ).then(() => {
        console.log("--------- Finished to process ----------");
        // console.log(JSON.stringify(this.historyList));
      });
    },
    saveVersionHistory() {
      if (this.currentVerItems.data[0].FFL_HST_NO == "") {
        let data = JSON.parse(JSON.stringify(this.historyList));
        let filtered = data.filter((item) => item.CURVER_YN === "Y");
        this.currentVerItems.data[0].FFL_HST_NO = filtered[0].HST_NO;
      }
      // console.log('HH'+JSON.stringify(this.historyList))
      this.currentVerItems.data[0].FFL_PRCS_NO = this.versionList.FFL_PRCS_NO;
      // console.log("SELECTED" + JSON.stringify(this.currentVerItems));
      Store.dispatch("fflayout/saveCurrentVer", this.currentVerItems).then(
        () => {
          console.log("--------- Finished to process ----------");
          this.$refs.successDialog.dialog = true;
        }
      );
    },
    onClickSave() {
      this.reFreshList();
    },
    selectVersion(item) {
      this.currentVerItems.data[0].FFL_HST_NO = item.HST_NO;
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },

    selectDialog(obj) {
      this.dragStart(obj);
    },

    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },

    /*  findIndexItem(item, arr, col) {
        let prop = (typeof col == 'undefined') ? 'id' : col;
        let index = arr.findIndex((row) => {
          return row[prop] === item[prop]
        })
        return (index > -1) ? index : null
      }, */
    openCheckIn() {
      if (this.versionList.FFL_CHKIN_YN === "N" && this.lockedFlag === false) {
        this.$refs.warningDialog.dialog = true;
        return;
      }
      this.dialogCheckIn(this.versionList.FFL_PRCS_NO);
    },
    openCheckOut(item) {
      this.fileId = item;
      this.$refs.checkOutDialog.dialog = true;
    },
    downloadFife() {
      let downloadfile = new DownloadFile();
      downloadfile.data[0].FILE_ID = this.fileId.FILE_ID;
      downloadfile.data[0].SAVE_NAME = this.versionList.FFL_FILE_NAME;

      Store.dispatch("common/DownloadFileFromServer", downloadfile).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    onClickOkay() {
      this.lockItems.data[0].FFL_PRCS_NO = this.versionList.FFL_PRCS_NO;
      this.lockItems.data[0].LOCK_YN = "Y";

      Store.dispatch("fflayout/updateLock", this.lockItems).then(() => {
        console.log("--------- Finished to process ----------");
        this.lockedFlag = true;
        this.reFreshList();
        this.downloadFife();
      });
    },
    onClickCancel() {
      this.downloadFife();
    },
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      let item = this.seletedDelete;
      this.deleteItems.data[0].FFL_PRCS_NO = this.versionList.FFL_PRCS_NO;
      this.deleteItems.data[0].FFL_HST_NO = item.HST_NO;
      this.deleteItems.data[0].FILE_ID = item.FILE_ID;

      Store.dispatch("fflayout/deleteSelectedHistory", this.deleteItems).then(
        () => {
          this.queryList();
          console.log("--------- Finished to process ----------");
        }
      );
    },
  },

  created() {
    this.queryList();
  },
};
</script>